import React, { Component } from "react";
import Parser from "rss-parser";
require("@/styles/ondemand.less");

class OnDemand extends Component {
  state = {
    title: "",
    description: "",
    items: [],
    currentPodcast: 0,
    isTransitioning: false,
  };
  parser = new Parser();
  componentDidMount() {
    fetch("https://anchor.fm/s/fb726f4/podcast/rss")
      .then((res) => res.text())
      .then((str) => this.parser.parseString(str))
      .then((data) => {
        console.log(data);
        this.setState({
          title: data.title,
          items: data.items,
        });
      });
  }
  increaseCurrentPodcast = () => {
    this.setState({
      isTransitioning: true,
    });
    setTimeout(() => {
      this.setState({
        currentPodcast: (this.state.currentPodcast + 1) % 5,
      });
      this.setState({
        isTransitioning: false,
      });
    }, 200);
  };
  decreaseCurrentPodcast = () => {
    this.setState({
      isTransitioning: true,
    });
    setTimeout(() => {
      this.setState({
        currentPodcast: (this.state.currentPodcast + 4) % 5,
      });
      this.setState({
        isTransitioning: false,
      });
    }, 200);
  };
  render() {
    return (
      <div className="onDemandContainer">
        <h1>On Demand</h1>
        <p>The Latest Podcasts From Purple Radio</p>
        <div
          className="onDemandShowContainer"
          style={{ opacity: this.state.isTransitioning ? "0%" : "100%" }}
        >
          <div className="onDemandShowPreview">
            <div
              className="onDemandShowPreviewImage previewLeft"
              onClick={this.decreaseCurrentPodcast}
              style={{
                backgroundImage: `url("${
                  this.state.items[(this.state.currentPodcast + 4) % 5]?.itunes
                    .image
                }")`,
              }}
            ></div>
            <div
              className="onDemandShowPreviewImageReflection previewLeft"
              style={{
                backgroundImage: `url("${
                  this.state.items[(this.state.currentPodcast + 4) % 5]?.itunes
                    .image
                }")`,
              }}
            ></div>
          </div>
          <div className="onDemandShow">
            <div className="onDemandImageContainer">
              <div
                className="onDemandImage"
                style={{
                  backgroundImage: `url("${
                    this.state.items[this.state.currentPodcast]?.itunes.image
                  }")`,
                }}
              ></div>
              <div
                className="onDemandImageReflection"
                style={{
                  backgroundImage: `url("${
                    this.state.items[this.state.currentPodcast]?.itunes.image
                  }")`,
                }}
              ></div>
            </div>
            <div className="onDemandDetailsContainer">
              <div className="onDemandDetails">
                <h1>{this.state.items[this.state.currentPodcast]?.title}</h1>
                <audio
                  controls
                  src={
                    this.state.items[this.state.currentPodcast]?.enclosure.url
                  }
                ></audio>
                <p>
                  {this.state.items[this.state.currentPodcast]?.contentSnippet}
                </p>
              </div>
            </div>
          </div>
          <div className="onDemandShowPreview">
            <div
              className="onDemandShowPreviewImage previewRight"
              onClick={this.increaseCurrentPodcast}
              style={{
                backgroundImage: `url("${
                  this.state.items[(this.state.currentPodcast + 1) % 5]?.itunes
                    .image
                }")`,
              }}
            ></div>
            <div
              className="onDemandShowPreviewImageReflection previewRight"
              style={{
                backgroundImage: `url("${
                  this.state.items[(this.state.currentPodcast + 1) % 5]?.itunes
                    .image
                }")`,
              }}
            ></div>
          </div>
        </div>
        <div className="linksContainer">
          <p>Find more at...</p>
          <div className="links">
            <a
              className="spotify"
              href="https://open.spotify.com/show/1NSJ0oOcYGVRWTKi0uSAd0"
            />
            <a
              className="apple"
              href="https://podcasts.apple.com/gb/podcast/purple-radio-on-demand/id1485160591"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default OnDemand;
